import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PricingProvider, usePricing } from './PricingContext';
import AdminTabs from './AdminTabs';
import PublishModal from './PublishModal';
import RateCardSection from './RateCardSection';
import ClientsSection from './ClientsSection';
import UsageSection from './UsageSection';
import AuditSection from './AuditSection';
import styles from '../../_css/Pricing.module.css';

function CreditBalanceBanner() {
  const { creditBalance, creditBalanceLoading } = usePricing();
  if (creditBalance == null && !creditBalanceLoading) return null;

  return (
    <div className={styles.balanceBar}>
      <div>
        <div className={styles.balanceLabel}>Credit balance</div>
        <div className={styles.balanceValue}>
          {creditBalanceLoading ? 'Loading…' : `${creditBalance}`}
        </div>
      </div>
    </div>
  );
}

function PricingRoutes() {
  return (
    <div className={styles.page}>
      <AdminTabs />
      <CreditBalanceBanner />
      <Routes>
        <Route index element={<Navigate to="rate-card" replace />} />
        <Route path="rate-card" element={<RateCardSection />} />
        <Route path="clients" element={<ClientsSection />} />
        <Route path="usage" element={<UsageSection />} />
        <Route path="audit" element={<AuditSection />} />
        <Route path="capacity" element={<Navigate to="/pricing/rate-card" replace />} />
        <Route path="*" element={<Navigate to="rate-card" replace />} />
      </Routes>
      <PublishModal />
    </div>
  );
}

export default function PricingIndex() {
  return (
    <PricingProvider>
      <PricingRoutes />
    </PricingProvider>
  );
}
